var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "VideoUploadView",
      class: {
        ..._vm.modes.map((m) => `VideoUploadView--${m}`),
        "VideoUploadView--withRemove": _vm.showRemove,
        "u-ErrorView": _vm.hasError,
        "VideoUploadView--error": _vm.isError,
        isLoader: _vm.isLoader,
      },
    },
    [
      _vm.title
        ? _c("div", { staticClass: "VideoUploadViewCaption" }, [
            _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "VideoUploadViewInner",
          style: _vm.innerStyles,
          on: {
            dragover: function ($event) {
              $event.preventDefault()
            },
            drop: _vm.onDrop,
          },
        },
        [
          _c(
            "label",
            { staticClass: "FullEditView VideoUploadViewLabel" },
            [
              _c("div", { staticClass: "VideoUploadViewLabelContent" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isLoader,
                        expression: "!isLoader",
                      },
                    ],
                    staticClass: "VideoUploadViewLabelText",
                    class: { fileUrl: _vm.showName },
                  },
                  [
                    _vm._t("default"),
                    _vm._v(" "),
                    _vm.fileUrl
                      ? _c("p", [_vm._v(_vm._s(_vm.showName))])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "VideoUploadViewInput",
                  attrs: { type: "file", name: "file" },
                  on: { change: _vm.onSelect },
                }),
              ]),
              _vm._v(" "),
              _vm.hasEdit
                ? _vm._t("edit", function () {
                    return [_c("edit-view")]
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "VideoUploadViewPreview",
            attrs: { alt: "" },
          }),
          _vm._v(" "),
          _vm._t("overlay"),
          _vm._v(" "),
          _vm.showRemove
            ? _vm._t("remove", function () {
                return [_c("remove-view", { on: { click: _vm.onRemove } })]
              })
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }